import { HStack, Text } from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import { RECENTLY_ENGAGED_DAYS } from './constants';
import { getDaysAgoLabel } from './utils';

// "Engaged <when>" row in a LaneBlockCard footer.
export const LastEngagedRow = ({ days }: { days: number }) => {
  const dotColor = days <= RECENTLY_ENGAGED_DAYS ? 'seafoam' : 'fuschia';

  return (
    <HStack alignItems={'center'} gap={2}>
      <Box w={'10px'} h={'10px'} borderRadius={'full'} bgColor={dotColor} />
      <Text color={'blueGray.600'} fontSize={'12px'} truncate>
        Engaged{' '}
        <Text
          as={'span'}
          color={'seafoam'}
          fontSize={'inherit'}
          lineHeight={'inherit'}
          fontWeight={600}
        >
          {getDaysAgoLabel(days)}
        </Text>
      </Text>
    </HStack>
  );
};
